import { UseFormReturn } from "react-hook-form"
import { PhoneCallIcon } from "../../../../../ui/icons/phoneCall"
import { XCircleIcon } from "../../../../../ui/icons/xCircle"
import Button from "../../../../../ui/molecules/button"
import Input from "../../../../../ui/molecules/input"
import { UpdateCompanyFormValues } from "./validation"

export function CompanyPhones({ form }: { form: UseFormReturn<UpdateCompanyFormValues> }) {
    const phones = form.watch("phones") || [{ phone: '', note: '' }]
    const errors = form.formState.errors.phones

    const updatePhone = (index: number, value: string) => {
        const updatedPhones = [...phones]
        updatedPhones[index] = { ...updatedPhones[index], phone: value }
        form.setValue("phones", updatedPhones, { shouldValidate: true })
    }

    const updateNote = (index: number, value: string) => {
        const updatedPhones = [...phones]
        updatedPhones[index] = { ...updatedPhones[index], note: value }
        form.setValue("phones", updatedPhones, { shouldValidate: true })
    }

    const removePhoneRow = (index: number) => {
        const updatedPhones = phones.filter((_, i) => i !== index)
        if (updatedPhones.length === 0) {
            form.setValue("phones", [{ phone: '', note: '' }], { shouldValidate: true })
        } else {
            form.setValue("phones", updatedPhones, { shouldValidate: true })
        }
    }

    const addPhone = () => {
        form.setValue("phones", [...phones, { phone: '', note: '' }], { shouldValidate: true })
    }

    return (
        <>
            {
                phones?.map((phoneItem, index) => {
                    const fieldError = Array.isArray(errors) ? errors[index] : undefined
                    return (
                        <div key={`phone-request-${index}`} className="flex items-end gap-2">
                            <div className="flex gap-2 flex-1">
                                <Input
                                    key={`phone-${index}`}
                                    label="Telefono"
                                    startIcon={<PhoneCallIcon color={""} size={0} />}
                                    value={phoneItem?.phone || ''}
                                    error={!!fieldError?.phone}
                                    supportingText={fieldError?.phone?.message || ''}
                                    onChangeText={(text) => updatePhone(index, text)}
                                />
                                <Input
                                    key={`note-${index}`}
                                    label="Note"
                                    value={phoneItem?.note || ''}
                                    error={!!fieldError?.note}
                                    supportingText={fieldError?.note?.message || ''}
                                    onChangeText={(text) => updateNote(index, text)}
                                />
                            </div>
                            {phones.length > 1 && (
                                <Button
                                    size={"sm"}
                                    iconPosition={"only"}
                                    icon={<XCircleIcon color={""} size={0} />}
                                    variant={"ghost"}
                                    color={"blue"}
                                    onClick={() => removePhoneRow(index)}
                                />
                            )}
                        </div>
                    )
                })
            }
            <div className="flex items-end justify-end">
                <Button
                    size={"sm"}
                    iconPosition={"off"}
                    variant={"link"}
                    color={"blue"}
                    label="Aggiungi numero di telefono"
                    onClick={() => addPhone()}
                />
            </div>
        </>
    )
}